// extracted by mini-css-extract-plugin
export var phone = "_3d-0";
export var phoneDragging = "_3d-1";